import { TOperation2 } from '../../util/varibles/interface';

const STATUS_COLOR_CLASS_NAMES: Record<string, string> = {
    excellent: 'text-[#5DACA5]',
    good: 'text-[#72A64E]',
    acceptable: 'text-[#677979]',
    poor: 'text-[#F69C6F]',
    very_poor: 'text-[#E95D5D]',
};

export default function StatusGrading({ operation }: { operation: TOperation2 }) {
    const status = operation.grading_status?.trim();
    const normalizedStatus = status?.toLowerCase().replace(/[\s-]+/g, '_');
    const colorClassName = normalizedStatus
        ? STATUS_COLOR_CLASS_NAMES[normalizedStatus] ?? 'text-comment'
        : 'text-comment';
    const displayStatus = status?.replace(/[_-]+/g, ' ');

    return <div className={`flex flex-col items-center text-[20px] capitalize ${colorClassName}`}>
        {displayStatus}
    </div>;
}
